module.exports = __webpack_public_path__ + "static/media/08.18c2adf2.png";